import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
// src/features/TptStaticData/columns.tsx
import { parseDate } from "@/lib/utils";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";

export type TptStaticData = {
  id: number;
  strategy_id: number | null;
  strategy_name: string | null;
  time_serie_file_date_id: number | null;
  time_serie_file_date_filename: string | null;
  created_at: string;
};

export const tpt_static_data_columns: ColumnDef<TptStaticData>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    id: "strategy",
    header: "Strategy",
    cell: ({ row }) => {
      const strategyId = row.original.strategy_id;
      const strategyName = row.original.strategy_name;
      return strategyId && strategyName ? (
        <Link
          href={toWorkspacePath(
            `/admin/qtl - referential/strategies/${strategyId}`,
          )}
          underline="hover"
          className="block w-full text-sm truncate"
        >
          {strategyName}
        </Link>
      ) : null;
    },
  },
  {
    id: "time_serie_file_date",
    header: "Time Series File",
    cell: ({ row }) => {
      const tsfdId = row.original.time_serie_file_date_id;
      const tsfdFilename = row.original.time_serie_file_date_filename;
      return tsfdId && tsfdFilename ? (
        <Link
          href={toWorkspacePath(
            `/admin/qtl - etl/time_serie_file_dates/${tsfdId}`,
          )}
          underline="hover"
          className="block w-full text-sm truncate"
        >
          {tsfdFilename}
        </Link>
      ) : null;
    },
  },
  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => parseDate(row.getValue("created_at")),
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => (
      <div className="flex justify-end space-x-2">
        <Link
          href={`${window.location.pathname}/${row.getValue("id")}`}
          className="text-xs"
          underline="hover"
        >
          {i18n.t("actions.edit")}
        </Link>
      </div>
    ),
  },
];
